export function getSavedUser() {
  try {
    const raw = localStorage.getItem("intectec_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getSessionId(user) {
  if (user && user.id) {
    return `customer-${user.id}`;
  }

  return "demo-session";
}
